import styled from "styled-components";

export const MasterVolumeContainer = styled.div`
  display: inline-flex;

  .ant-popover-inner {
    background: ${(props: any) => props.theme.backgroundDark};
    border-radius: 4px;
  }

  .ant-popover-arrow-content {
    background: ${(props: any) => props.theme.backgroundDark};
  }

  .ant-popover-inner-content {
    padding: 8px;
  }
`;
